import { useCallback } from 'react';
import axiosInstance from '../../../axiosInstance';

/**
 * useLinkedStudiesApi Hook
 *
 * Pure API hook for linked studies operations.
 *
 * @returns {Object} - { getEligibleLinkedStudies, getLinkedStudies }
 */
const useLinkedStudiesApi = () => {
  const getEligibleLinkedStudies = useCallback(async (workflowVersionId) => {
    const response = await axiosInstance.get(
      `/api/requests/eligible-linked-studies/${workflowVersionId}`
    );
    return response.data;
  }, []);

  const getLinkedStudies = useCallback(async (requestId) => {
    const response = await axiosInstance.get(
      `/api/requests/${requestId}/linked-studies`
    );
    return response.data;
  }, []);

  return {
    getEligibleLinkedStudies,
    getLinkedStudies,
  };
};

export default useLinkedStudiesApi;
